export class UpdateSwitchCompanyModel {
    valueCompany : number;
    qoPhoto : number;
    dataWarehouse : number;
    location:number;
    companySurr: number;
    isAvailable: number;
    isBadge: number;
    isHide: number;
    isActiveLocationOffLimit: number;
    isGeoMap: number;
    isAccessWebhook: number;
    isChange : boolean =false;
  }
